import { render } from "./ManageCoursePermission.vue?vue&type=template&id=617ca0d6&scoped=true"
import script from "./ManageCoursePermission.vue?vue&type=script&lang=js"
export * from "./ManageCoursePermission.vue?vue&type=script&lang=js"

import "./ManageCoursePermission.vue?vue&type=style&index=0&id=617ca0d6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-617ca0d6"]])

export default __exports__